// extracted by mini-css-extract-plugin
export default {"service_card":"KeyServiceCard_service_card__BwVU3","service_icon":"KeyServiceCard_service_icon__lRCgM","service_btn":"KeyServiceCard_service_btn__-yzY0"};